import { observable, action, computed } from 'mobx'

import favoritesStore from './favoritesStore'
import dropdownStore from './dropdownStore'
import userStore from './userStore'
import exploreStore from './exploreStore'

import anchorScroll from '../utils/anchorScroll'

class guidedIntroductionStore {
  @observable step = 0
  @observable skippedIntroduction = false
  @observable inProgress = false

  @computed get showIntroduction() {
    if(userStore.currentUser && !this.skippedIntroduction && this.step < 6 && (this.inProgress || (favoritesStore.fetchedFavoritesOnce && favoritesStore.favoriteCategories.length === 0))) {
      return true
    }
    return false
  }

  @action.bound startIntroduction() {
    this.inProgress = true
    this.grayoutHeader()
    this.step = 1
    this.goToStep(this.step)
    this.addShowToClassList(this.step)
  }

  @action.bound nextStep() {
    this.removeShowFromClassList(this.step)
    this.step = this.step + 1

    this.goToStep(this.step)
    this.addShowToClassList(this.step)
  }

  @action.bound goToStep() {
    switch(this.step){
      case 1: anchorScroll('#favorites', '/'); break;
      case 2: anchorScroll('#favorites', '/'); break;
      case 3: this.doStepThree(); break;
      case 4: this.doStepFour(); break;
      case 5: dropdownStore.openProfileDropdown(); anchorScroll('top', '/'); break;
      default: this.endIntroduction();
    }
  }

  doStepThree() {
    anchorScroll('top', '/')
    exploreStore.expand()
  }

  doStepFour() {
    exploreStore.collapse()
    dropdownStore.openSearchDropdown()
    anchorScroll('top', '/')
  }

  @action.bound endIntroduction() {
    this.skippedIntroduction = true
    this.step = 6
    this.removeAll()
    dropdownStore.closeDropdown()
  }

  @action.bound reset() {
    this.step = 0
    this.skippedIntroduction = false
    this.inProgress = false
  }

  /* add or remove highlight class of steps */
  removeAll() {
    let step = 1
    for(step; step < 6; step++) {
      this.removeShowFromClassList(step)
    }
    this.disableGrayoutHeader()
  }

  addShowToClassList(step) {
    document.getElementsByName('step-' + step).forEach(elt => {
      elt.classList.add('showIntroduction')
      step !== 1 && elt.classList.add('pointer-events-none')
    })
  }

  removeShowFromClassList(step) {
    document.getElementsByName('step-' + step).forEach(elt => {
      elt.classList.remove('showIntroduction')
      step !== 1 && elt.classList.remove('pointer-events-none')
    })
  }

  /* Header grayout and again show it */
  grayoutHeader() {
    document.getElementsByName('header-grey').forEach(elt => elt.classList.remove('hidd'))
    document.getElementsByName('dropdown-grey').forEach(elt => elt.classList.remove('hidd'))
  }

  disableGrayoutHeader() {
    document.getElementsByName('header-grey').forEach(elt => elt.classList.add('hidd'))
    document.getElementsByName('dropdown-grey').forEach(elt => elt.classList.add('hidd'))
  }

}

export default new guidedIntroductionStore()



// WEBPACK FOOTER //
// ./src/stores/guidedIntroductionStore.js